const POUCHES_ORIGIN = 'https://apps.tomippe.jp';

/** Electron / Capacitor は capacitor:// や file:// 起点のため API は絶対 URL が必要 */
export function isPouchesNativeShell(): boolean {
  try {
    const w = window as {
      electron?: unknown;
      Capacitor?: { isNativePlatform?: () => boolean };
    };
    if (w.electron) return true;
    if (w.Capacitor?.isNativePlatform?.()) return true;
  } catch {
    // ignore
  }
  return false;
}

/** `/pouches/api/...` 形式のパスを、実行環境に応じた URL に変換 */
export function getPouchesApiUrl(relativePath: string): string {
  const path = relativePath.startsWith('/pouches/')
    ? relativePath
    : `/pouches/${relativePath.replace(/^\//, '')}`;
  return isPouchesNativeShell() ? `${POUCHES_ORIGIN}${path}` : path;
}

/** Private Share 用の一時ファイル削除 API */
export function getDeleteTempFileUrl(serverFilePath: string): string {
  const fileName = serverFilePath.split('/').pop()?.split('?')[0] || '';
  return getPouchesApiUrl(`/api/delete-temp.php?filename=${encodeURIComponent(fileName)}`);
}
